import { Route } from "../RouteModel";
import { Config as ConfigIcon } from "@volt_developers/react-ui-components";
import { applicationRoutes } from "./applications";
import { accountRoutes } from "./accounts";
import customerRoutes from "./customers";
import { userRoutes } from "./users";

export const configurationRoutes: Route = {
  i18nName: "Configuration",
  icon: ConfigIcon,
  path: "/configuration",
  showChildrenInSidebar: true,
  can: {
    do: "list",
    on: "client",
  },
  children: [applicationRoutes, accountRoutes, userRoutes, customerRoutes],
};
